import { InMemoryCache } from '@apollo/client';

/**
 * Data Cache
 * @see https://www.apollographql.com/docs/react/advanced/caching/
 */
const cache = new InMemoryCache({ addTypename: false });

export default cache;
